
/* styles */
require("!!./../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter?id=data-v-1dffcc04&scoped=true!./../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ServiceChoices.vue")

var Component = require("!./../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../node_modules/vue-loader/lib/selector?type=script&index=0!./ServiceChoices.vue"),
  /* template */
  require("!!./../../node_modules/vue-loader/lib/template-compiler?id=data-v-1dffcc04!./../../node_modules/vue-loader/lib/selector?type=template&index=0!./ServiceChoices.vue"),
  /* scopeId */
  "data-v-1dffcc04",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/panels/ServiceChoices.vue
// module id = 843
// module chunks = 2